import t from "./highrise645.mjs";
import o from "./highrise646.mjs";
import f from "./highrise647.mjs";
import i from "./highrise648.mjs";
import e from "./highrise649.mjs";
function c(r) {
  return typeof r == "function" ? r : r == null ? f : typeof r == "object" ? i(r) ? o(r[0], r[1]) : t(r) : e(r);
}
export {
  c as default
};
